/**
 * Attempt to count the number of lines and width of the content. This is to stop the content jumping around the place
 * a translation is loading. This isn't perfect as it's hard to work out with Markdown generating nested HTML.
 */
export const getSkeletonSize = (textElement: HTMLDivElement) => {
    const height = textElement.offsetHeight;
    const lineHeight = parseInt(window.getComputedStyle(textElement).lineHeight.replace("px", ""), 10);
    return { lineCount: Math.max(1, Math.floor(height / lineHeight)), width: textElement.clientWidth };
};
